import BadgeIcon from '#assets/svg/Badge.svg';
import ExpertBadge from '#assets/svg/ExpertBadgeIcon.svg';
import EmptyContent from 'src/refactor_shared/ui/empty-content';

const TrainerBadge = ({ badge }: { badge: any[] }) => {
  return (
    <div className="flex flex-col gap-20">
      <p className="text-[18px] font-bold">피벗 전문가 배지</p>
      {badge?.length ? (
        badge.map((item, index) => (
          <div key={index}>
            <img src={item.isTop ? BadgeIcon : ExpertBadge} />
            <p>
              {item.isTop && '2023 '}
              {item.Label}
              <br />
              {item.isTop && '상위 1%'}
            </p>
          </div>
        ))
      ) : (
        <EmptyContent>받은 배지가 없습니다.</EmptyContent>
      )}
    </div>
  );
};

export default TrainerBadge;
